/* cl-ui.js — camada interativa do clone breeze-14 (vanilla, sem slick/Swiper/custom elements do tema).
   - [data-cl-fade="ms"]: mensagens empilhadas que alternam em fade (barra de anuncio)
   - trilhos: [data-cl-track] e o slider do Dawn (div.ce-slider-component > ul.slider) deslizam por
     scroll-snap; .slider-button--prev/--next e [data-cl-prev]/[data-cl-next] andam um item;
     .slider-counter--current/--total acompanham; data-cl-autoplay="ms" avanca sozinho.
   - carrinho: icone do header e ATC abrem a gaveta (secao cl-cart-drawer). */
(function () {
  'use strict';

  /* ---------------- fade ---------------- */
  function initFade(box) {
    if (box.__cl) return;
    box.__cl = true;
    var it = box.querySelectorAll('[data-cl-fade-item]');
    var ms = parseInt(box.getAttribute('data-cl-fade') || '2500', 10);
    if (it.length < 2 || navigator.webdriver) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      it[i].classList.remove('is-active');
      i = (i + 1) % it.length;
      it[i].classList.add('is-active');
    }, ms);
  }

  /* ---------------- trilhos ---------------- */
  function items(track) {
    return Array.prototype.filter.call(track.children, function (c) {
      return c.nodeType === 1 && c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT' && c.offsetWidth > 0;
    });
  }
  function step(track) {
    var it = items(track);
    if (it.length > 1) return Math.abs(it[1].offsetLeft - it[0].offsetLeft) || track.clientWidth;
    return track.clientWidth;
  }
  function index(track) { return Math.round(track.scrollLeft / (step(track) || 1)); }
  function go(track, i, loop) {
    var it = items(track);
    if (!it.length) return;
    var n = it.length, max = track.scrollWidth - track.clientWidth;
    i = loop ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: Math.min(it[i].offsetLeft - it[0].offsetLeft, max), behavior: 'smooth' });
  }
  function root(track) {
    return track.closest('[data-cl-slider]') || track.closest('.ce-slider-component') ||
      track.closest('[class*="cl-sec-"]') || track.parentNode;
  }

  function initTrack(track) {
    if (track.__cl) return;
    track.__cl = true;
    var r = root(track);
    var scope = r.closest('[class*="cl-sec-"]') || r;
    var loop = track.hasAttribute('data-cl-loop');
    function bind(sel, d) {
      Array.prototype.forEach.call(scope.querySelectorAll(sel), function (b) {
        if (b.__clb) return;
        b.__clb = true;
        b.removeAttribute('disabled');
        b.addEventListener('click', function (e) { e.preventDefault(); go(track, index(track) + d, loop); });
      });
    }
    bind('[data-cl-prev], .slider-button--prev', -1);
    bind('[data-cl-next], .slider-button--next', 1);
    var cur = scope.querySelector('.slider-counter--current');
    var tot = scope.querySelector('.slider-counter--total');
    var dotsBox = scope.querySelector('[data-cl-dots]');
    function paint() {
      var i = index(track), n = items(track).length;
      if (cur) cur.textContent = Math.min(i + 1, n);
      if (tot) tot.textContent = n;
      if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (d, k) {
        d.classList.toggle('is-selected', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      var prev = scope.querySelector('.slider-button--prev'), next = scope.querySelector('.slider-button--next');
      if (!loop && prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      if (!loop && next) next.toggleAttribute('disabled', track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
    }
    if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(track, k, loop); });
    });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick); tick = setTimeout(paint, 60);
      track.dispatchEvent(new CustomEvent('cl:slide', { detail: { index: index(track) } }));
    }, { passive: true });
    paint();

    // arrastar com o mouse (o toque ja e nativo)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      if (track.scrollWidth <= track.clientWidth + 2) return;
      down = true; moved = false; sx = e.pageX; sl = track.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('cl-dragging'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (moved) { track.classList.remove('cl-dragging'); go(track, Math.round(track.scrollLeft / (step(track) || 1)), false); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    var ms = parseInt(track.getAttribute('data-cl-autoplay') || '0', 10);
    if (ms > 0 && items(track).length > 1 && !navigator.webdriver) {
      var paused = false;
      r.addEventListener('mouseenter', function () { paused = true; });
      r.addEventListener('mouseleave', function () { paused = false; });
      r.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else go(track, index(track) + 1, false);
      }, ms);
    }
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-fade]'), initFade);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-track], .ce-slider-component > ul.slider, .ce-slider-component > .slider, ul.cl-swipe'), initTrack);
  }

  /* ---------------- carrinho ---------------- */
  function openCart() { document.dispatchEvent(new CustomEvent('cl:cart:open')); }
  window.clOpenCart = openCart;

  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-cl-cart-drawer]')) return;
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], cart-icon, .header-actions__cart-icon, [data-cl-cart-toggle]');
    if (!a || a.closest('[data-cl-cart-drawer]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCart();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-cl-cart-drawer]')) return;
    if (form.hasAttribute('data-cl-native-submit') || form.hasAttribute('data-cl-bundle')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var go = window.clCartPost ? window.clCartPost('/cart/add.js', new FormData(form))
      : fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    go.then(function (res) {
        if (!res || !res.ok) {
          var box = form.querySelector('.product-form__error-message-wrapper, [role="alert"]');
          if (box && res) { box.hidden = false; box.textContent = res.j.description || res.j.message || 'Error'; }
          return;
        }
        document.dispatchEvent(new CustomEvent('cl:cart:open', { detail: { added: !!window.clCartPost } }));
      })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* ---------------- colecao: "Sort by" do Sense navega com ?sort_by= ---------------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[name="sort_by"]');
    if (!s) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'FacetFiltersForm') e.preventDefault();
  });

  function boot() { initAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.clInitTracks = initAll;
})();
